import AddressVerification from './AddressVerification'

export default AddressVerification
